import React, { useState } from 'react';
import './CreateCustomer.css';
import { Button, Card, Form } from 'react-bootstrap';
import image4 from '../../images/c4.png'
import { useLocation, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { insertCustomer } from '../../service/customerService';

const CreateCustomer = () => {


    let navigate = useNavigate();
    const { state } = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const [companyName, setCompanyName] = useState("");
    const [subscriptionNumber, setSubscriptionNumber] = useState("");
    const [nickName, setNickName] = useState("");

    if (!state || !state.person) {
        window.location = '/'
        return;
    }
    const submitHandler = async (event) => {
        event.preventDefault();
        if (!companyName || !nickName) {
            return toast.error('نام کمپانی را وارد کنید')
        }
        try {
            setIsLoading(true);
            const { status, data } = await insertCustomer({ companyName, subscriptionNumber, nickName });
            if (status === 201) {
                if (data.message.includes('already exist!')) {
                    toast.error('کمپانی با این نام قبلا ثبت شده است')
                }
                else if (data.message.includes('is registered!')) {
                    toast.success('مشتری جدید ایجاد شد')
                    navigate(-1)
                }

            }

        } catch (err) {
            toast.error('خطایی رخ داده است')
        }
        setIsLoading(false)
    };
    return (
        <div className='d-flex justify-content-center'>
            <div className='mt-5'>

                <Card className='new-customer rtl'>
                    <Card.Body>
                        <Card.Title>
                            <img src={image4} style={{ width: '40px' }} alt='' />
                        </Card.Title>
                        <Card.Subtitle className="mb-3 text-muted d-flex justify-content-between">
                            <div>مشتری جدید</div>
                        </Card.Subtitle>
                        <Form>
                            <Form.Group className="mb-3" controlId="exampleForm2.ControlInput">
                                <Form.Label>نام کمپانی (لاتین)</Form.Label>
                                <Form.Control
                                    type="text"
                                    autoComplete='off'
                                    className='ltr'
                                    value={companyName}
                                    onChange={e => setCompanyName(e.target.value)}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="exampleForm3.ControlInput">
                                <Form.Label>شماره اشتراک (لاتین)</Form.Label>
                                <Form.Control
                                    type="text"
                                    autoComplete='off'
                                    className='ltr'
                                    value={subscriptionNumber}
                                    onChange={e => setSubscriptionNumber(e.target.value)}
                                />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="exampleForm2.ControlInput">
                                <Form.Label>نام کمپانی <small>(ترجیحا فارسی -  نمایش در باشگاه و منو آنلاین)</small></Form.Label>
                                <Form.Control
                                    type="text"
                                    autoComplete='off'
                                    className='rtl'
                                    value={nickName}
                                    onChange={e => setNickName(e.target.value)}
                                />
                            </Form.Group>
                            <div className='text-center'>
                                <Button
                                    type='button'
                                    variant="success"
                                    onClick={submitHandler}
                                    style={{ width: '100px', marginLeft: '5px' }}
                                    disabled={isLoading || !companyName || !nickName}
                                >
                                    ایجاد
                                </Button>
                                <Button
                                    type='button'
                                    variant="secondary"
                                    style={{ width: '100px' }}
                                    onClick={() => navigate(-1)}
                                    disabled={isLoading}
                                >
                                    بازگشت
                                </Button>

                            </div>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
}

export default CreateCustomer;